import classNames from "classnames";
import { Link } from "gatsby";
import React from "react";
import Style from "styles/components/news.module.scss";

const NewsPresenter = ({ news }) => {
  const list = Array.isArray(news) ? news : [];
  return (
    <section className={classNames(Style.news)}>
      <h2 className={classNames(Style.news__title)}>
        <span>最新情報</span>
      </h2>
      <div>
        {list.map(item => {
          return (
            <Link className={classNames(Style.news__item)} key={item.id} to={item.link}>
                <div className={classNames(Style.news__item__label)}>{item.label}</div>
                <div className={classNames(Style.news__item__labelWrapper)}>
                  <div className={classNames(Style.news__item__date)}>{item.publishDate}</div>
                  <div className={classNames(Style.news__item__title)}>
                    {item.title}
                  </div>
                </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

const News = ({ news }) => {
  return <NewsPresenter news={news} />;
};

export default News;
